import PremiumLandingPage, { getServerSideProps } from "src/lib/pages/PremiumLandingPage";

export { getServerSideProps };

export default PremiumLandingPage;
